<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="proct-parentdiv" style="background: #ffffff">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center mt-3">
					<div class="pointer" @click="goToDashboard()">
						<img src="../../assets/icons/Reports/bckarrow.svg" alt="" />
					</div>
					<div class="heading headtext ml-3">
						<span>{{ $route.query.name }}</span>
					</div>
				</div>
				<div class="position-relative">
					<div class="d-flex align-items-center mt-3">
						<div
							class="vpt-testbtn pointer d-flex align-items-center justify-content-between ml-2"
							@click="(showtypecard = !showtypecard), (filterview = false)"
							ref="testbox"
						>
							<div class="sorttext ml-3">Test Type</div>
							<div class="sortline ml-2"></div>
							<div
								class="d-flex justify-content-center align-items-center mr-4"
							>
								<div class="ml-3">
									{{
										typeselected == 2
											? "All"
											: typeselected == 1
											? "Active"
											: "Inactive"
									}}
								</div>
								<div class="ml-3">
									<img
										v-if="showtypecard"
										src="../../assets/uparrow.svg"
										alt=""
									/>
									<img v-else src="../../assets/downarrow.svg" alt="" />
								</div>
							</div>
						</div>
						<div
							v-if="showtypecard"
							ref="testdropdown"
							v-closable="{
								exclude: ['testbox', 'testdropdown'],
								handler: 'hideTestFunction',
							}"
						>
							<div class="pr-test-sortcard jdtypecard p-0">
								<div @click="showtypecard = false" class="xMarkCancel pointer">
									<img src="../../assets/xmark.svg" alt="" />
								</div>
								<b-form-group
									class="sec-mcq-datacard jdtyperadio"
									v-for="i in typeoptions"
									:key="i.value"
								>
									<b-form-radio
										class="m-1 sort-radio-color"
										size="sm"
										v-model="typeselected"
										:value="i.value"
										@change="
											getProcteringAllTests(),
												(LoaderStatus = true),
												(showtypecard = false)
										"
									>
										{{ i.text }}
									</b-form-radio>
								</b-form-group>
							</div>
						</div>
						<div
							class="vpt-reportbtn ml-3 pointer relativeclass"
							@click="filter(), hideTestFunction()"
							ref="filterbox"
						>
							<div>Filter</div>

							<div class="ml-2 d-flex relativeclass">
								<span><img src="../../assets/filtericon.svg" alt="" /> </span>
							</div>
							<div
								class="proct-filter-count mb-3"
								v-if="storeSelectedTest.length != 0 && applyfilter == true"
							>
								{{ storeSelectedTest.length }}
							</div>
						</div>
						<div
							v-if="filterview"
							class="pr-test-cj-filter-modal"
							ref="filterdropdown"
							v-closable="{
								exclude: ['filterbox', 'filterdropdown'],
								handler: 'closeFilter',
							}"
						>
							<div @click="closeFilter()" class="xMarkCancel">
								<img src="../../assets/xmark.svg" alt="" />
							</div>
							<b-overlay :show="showLoaderfilter" rounded="sm">
								<div v-if="showtest">
									<div class="d-flex align-items-start">
										<div class="pointer" @click="closeTest()">
											<img
												src="../../assets/icons/Reports/bckarrow.svg"
												alt=""
											/>
										</div>
										<div class="ml-2 jd-testhead text-truncate">
											<span class="folder-bar-head">Tests</span>(<strong
												v-b-tooltip.hover="{ variant: 'secondary' }"
												:title="selTopicName"
												>{{ selTopicName }}</strong
											>)
										</div>
									</div>
								</div>
								<div v-else>
									<div class="jd-testhead">
										<span class="folder-bar-head">Topics</span>
									</div>
								</div>
								<div class="position-relative recinput mt-2">
									<div class="vpts-recsearchicon-pos">
										<img src="../../assets/searchicon.svg" alt="" />
									</div>
									<b-form-input
										class="inputField"
										type="text"
										:placeholder="
											`${
												showtest == true ? 'Search in Tests' : ' Search Topics'
											}`
										"
										v-model="searchFilter"
										debounce="500"
										@update="searchFilterM()"
									>
									</b-form-input>
									<div class="searchicon">
										<img
											class="pointer"
											v-show="searchFilter.length"
											src="../../assets/icons/Qpbuilder/cross.svg"
											@click="(searchFilter = ''), searchFilterM()"
											alt=""
										/>
									</div>
									<div class="pd-filtercontent-modal" @scroll="scroll">
										<template
											v-if="showtest == false && filterTopic.length !== 0"
										>
											<div
												v-for="(i, index) in filterTopic"
												:key="index"
												class="pd-checkboxes-background pointer m-1"
											>
												<div
													class="d-flex align-items-center justify-content-between"
												>
													<b-form-checkbox
														:id="i.topicID"
														:value="i.topicID"
														size="sm"
														@change="
															selectTopicIDS(i.topicID, i.testIDs, index)
														"
														name="flavour-4a"
														v-model="selectedTopic"
													>
														<div class="text-truncate">{{ i.name }}</div>
													</b-form-checkbox>
													<div
														@click="
															(selectedTopicIndex = index),
																(page = 0),
																closeTopic(i),
																copy(),
																(showLoaderfilter = true),
																getProctoringFilterData('TEST', storeTopicId)
														"
													>
														<img
															src="../../assets/icons/proctoring/rightarrow.svg"
															alt=""
														/>
													</div>
												</div>
											</div>
											<div
												v-if="this.filterPageEnd != this.totalFilterData"
												style="margin: auto"
												class="d-flex justify-content-center mb-3"
											>
												<b-spinner small label="Loading..."></b-spinner>
											</div>
										</template>
										<template v-if="showtest && filterTest.length != 0">
											<div
												class="pd-checkboxes-background pointer m-1"
												v-for="(i, index) in filterTest"
												:key="index"
											>
												<b-form-checkbox
													size="sm"
													name="flavour-4a"
													:value="i.testID"
													v-model="selectedTest"
													@change="selectTestIDs(i.topicID)"
												>
													<div class="text-truncate" style="color: #6d6d6d">
														{{ i.name }}
													</div>
												</b-form-checkbox>
											</div>
										</template>
										<template
											v-if="
												filterTopic.length === 0 &&
													filterTest.length === 0 &&
													searchFilter == ''
											"
										>
											<span
												class="archivebox-heading mt-2 d-flex justify-content-center wordbreak"
											>
												Currently no topics added "
											</span>
										</template>
										<template
											v-if="
												filterTopic.length === 0 &&
													filterTest.length === 0 &&
													searchFilter != ''
											"
										>
											<span
												class="archivebox-heading mt-2 d-flex justify-content-center wordbreak"
											>
												No matching results for "{{ searchFilter }}"
											</span>
										</template>
									</div>
								</div>
								<div
									class="d-flex justify-content-between align-items-center mt-3"
								>
									<div
										class="pd-clearfilter pointer"
										:class="
											selectedTest == '' &&
											selectedTopic == '' &&
											searchFilter == ''
												? storeSelectedTest.length == 0
													? 'disabled-text'
													: 'pointer'
												: 'pointer'
										"
										@click="
											selectedTest == '' &&
											selectedTopic == '' &&
											searchFilter == ''
												? storeSelectedTest.length == 0
													? ''
													: clearfilter()
												: clearfilter()
										"
									>
										Clear Filter
									</div>
									<div>
										<b-button
											class="addbtn pl-3 pr-3"
											:disabled="
												selectedTest == '' &&
													selectedTopic == '' &&
													searchFilter == ''
											"
											@click="
												(filterview = false),
													(applyfilter = true),
													getProcteringAllTests()
											"
										>
											Apply
										</b-button>
									</div>
								</div>
							</b-overlay>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex proct-content-container">
				<div
					class="proct-test-viewcontainer"
					:class="
						total == 0
							? 'proct-test-viewcontainer-full'
							: 'proct-test-viewcontainer'
					"
				>
					<div class="tabbed mt-3">
						<b-tabs v-model="tabIndex">
							<b-tab
								@click="
									(tabIndex = 0),
										getProcteringAllTests(),
										(currentPage = 1),
										(LoaderStatus = true)
								"
								title="All"
							>
								<div class="position-relative">
									<div class="vpt-test-tab-container">
										<div
											v-if="total == 0"
											class="d-flex flex-column align-items-center justify-content-center h-100"
										>
											<div v-if="searchTopicTest != ''">
												<img src="../../assets/searchnotfound.svg" alt="" />
												<div class="text-center">
													<span class="searchnotfound"
														>No matching results for
														<span class="searchtext text-break">
															"{{ searchTopicTest }}"
														</span>
													</span>
												</div>
											</div>
											<div v-else>
												<img src="../../assets/nocandidate.svg" alt="" />
												<div class="mt-3">
													<span class="nocandidate"
														>Currently there is no test.
													</span>
												</div>
											</div>
										</div>
										<template v-else
											><div
												v-for="(testdata, index) in gettests"
												:key="index"
												class="d-flex align-items-center mt-3 pointer"
												:class="[
													storeTopic.testID == testdata.testID
														? 'proct-gicards-selected'
														: 'proct-gicards',
												]"
												@click="
													storeTopic.testID == testdata.testID
														? ''
														: handleCandidateClick(testdata)
												"
											>
												<div
													class="proct-gicards-gridcolorbar"
													v-if="storeTopic.testID != testdata.testID"
												></div>
												<div class="d-flex flex-column" style="width: 35%">
													<div class="d-flex align-items-center proct-gt-tctxt">
														<div class="text-truncate mr-3">
															Topic :
															{{ getFormattedTopicName(testdata.topicName) }}
														</div>
													</div>
													<div class="proct-grpname mt-2">
														<div class="text-truncate mr-3">
															{{ testdata.testName }}
														</div>
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 15%">
													<div class="proct-gt-tctxt">Sections</div>
													<div class="proct-gt-tccounttxt">
														{{ testdata.sectionCount }}
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 25%">
													<div class="proct-gt-tctxt">Marks</div>
													<div
														v-if="testdata.marks < 10"
														class="proct-gt-candcounttxt"
													>
														0{{ testdata.marks.toString().slice(0, 4) }}
													</div>
													<div v-else class="proct-gt-candcounttxt">
														{{ testdata.marks.toString().slice(0, 5) }}
													</div>
												</div>
												<div class="d-flex" style="width: 20%">
													<div
														v-if="testdata.active"
														class="active-btn d-flex align-items-center justify-content-center"
													>
														<div class="vpt-activetxt">Active</div>
													</div>
													<!-- please note below code is for iactive  -->

													<div
														v-else
														class="inactive-btn d-flex align-items-center justify-content-center"
													>
														<div class="inactive-text-proc">Inactive</div>
													</div>
												</div>
												<div style="width: 5%">
													<img
														src="../../assets/visibility_off_black (2).svg"
														alt=""
														v-if="storeTopic.testID == testdata.testID"
													/>
													<img
														v-else
														src="../../assets/preview eye (2).svg"
														alt=""
													/>
												</div></div
										></template>
									</div>
								</div>
								<div
									class="vpt-paginaTion d-flex justify-content-between align-items-center"
								>
									<div class="d-flex">
										<span class="qb-gotopage-text p-1">Go to page</span>
										<b-form-input
											type="text"
											class="qb-pagination-num mr-1"
											v-model.trim="goToPage"
											@keyup.enter="
												goToPage === null || goToPage == '' || iscontainsNumber
													? ''
													: goToPageNo(goToPage)
											"
										></b-form-input>
										<b-button
											:disabled="
												goToPage === null || goToPage == '' || iscontainsNumber
											"
											class="qb-pagination-addbtn"
											@click="goToPageNo(goToPage)"
										>
											<span
												><img src="../../assets/whiterightarrow.svg" alt=""
											/></span>
										</b-button>
									</div>
									<div class="pagination">
										<b-pagination
											v-model.number="currentPage"
											@input="goToPageNum()"
											:total-rows="total"
											:per-page="testCount"
											align="center"
											first-number
											last-number
										>
											<template #prev-text
												><span
													><img
														src="../../assets/leftvector.svg"
														alt=""
													/> </span
											></template>
											<template #next-text
												><span
													><img src="../../assets/rightarrow.svg" alt=""/></span
											></template>
										</b-pagination>
									</div>
									<div class="qb-gotopage-text mr-2">
										Results : <span v-if="pageStart + 1 > total">0</span
										><span v-else>{{ pageStart + 1 }}</span> - {{ pageEnd }}
										<span class="pl-1"></span> of <span class="pr-1"></span
										>{{ total }}
									</div>
								</div>
							</b-tab>
							<b-tab
								@click="
									(tabIndex = 1),
										getProcteringAllTests(),
										(currentPage = 1),
										(LoaderStatus = true)
								"
								title="Expired"
							>
								<div class="position-relative">
									<div class="vpt-test-tab-container">
										<div
											v-if="total == 0"
											class="d-flex flex-column align-items-center justify-content-center h-100"
										>
											<div v-if="searchTopicTest != ''">
												<img src="../../assets/searchnotfound.svg" alt="" />
												<div class="text-center">
													<span class="searchnotfound"
														>No matching results for
														<span class="searchtext text-break">
															"{{ searchTopicTest }}"
														</span>
													</span>
												</div>
											</div>
											<div v-else>
												<img src="../../assets/nocandidate.svg" alt="" />
												<div class="mt-3">
													<span class="nocandidate"
														>Currently there is no test.
													</span>
												</div>
											</div>
										</div>
										<template v-else
											><div
												class="d-flex align-items-center mt-3 pointer"
												v-for="(testdata, index) in gettests"
												:key="index"
												:class="[
													storeTopic.testID == testdata.testID
														? 'proct-gicards-selected'
														: 'proct-gicards',
												]"
												@click="
													storeTopic.testID == testdata.testID
														? ''
														: handleCandidateClick(testdata)
												"
											>
												<div
													class="proct-gicards-gridcolorbar"
													v-if="storeTopic.testID != testdata.testID"
												></div>
												<div class="d-flex flex-column" style="width: 35%">
													<div class="d-flex align-items-center proct-gt-tctxt">
														<div class="text-truncate mr-3">
															Topic :
															{{ getFormattedTopicName(testdata.topicName) }}
														</div>
													</div>
													<div class="proct-grpname mt-2">
														<div class="text-truncate mr-3">
															{{ testdata.testName }}
														</div>
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 15%">
													<div class="proct-gt-tctxt">Sections</div>
													<div class="proct-gt-tccounttxt">
														{{ testdata.sectionCount }}
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 25%">
													<div class="proct-gt-tctxt">Marks</div>
													<div
														v-if="testdata.marks < 10"
														class="proct-gt-candcounttxt"
													>
														0{{ testdata.marks.toString().slice(0, 4) }}
													</div>
													<div v-else class="proct-gt-candcounttxt">
														{{ testdata.marks.toString().slice(0, 5) }}
													</div>
												</div>
												<div class="d-flex" style="width: 20%">
													<div
														v-if="testdata.active"
														class="active-btn d-flex align-items-center justify-content-center"
													>
														<div class="vpt-activetxt">Active</div>
													</div>
													<!-- please note below code is for iactive  -->

													<div
														v-else
														class="inactive-btn d-flex align-items-center justify-content-center"
													>
														<div class="inactive-text-proc">Inactive</div>
													</div>
												</div>
												<div style="width: 5%">
													<img
														src="../../assets/visibility_off_black (2).svg"
														alt=""
														v-if="storeTopic.testID == testdata.testID"
													/>
													<img
														v-else
														src="../../assets/preview eye (2).svg"
														alt=""
													/>
												</div></div
										></template>
									</div>
								</div>
								<div
									class="vpt-paginaTion d-flex justify-content-between align-items-center"
								>
									<div class="d-flex">
										<span class="qb-gotopage-text p-1">Go to page</span>
										<b-form-input
											type="text"
											class="qb-pagination-num mr-1"
											v-model.trim="goToPage"
											@keyup.enter="
												goToPage === null || goToPage == '' || iscontainsNumber
													? ''
													: goToPageNo(goToPage)
											"
										></b-form-input>
										<b-button
											:disabled="
												goToPage === null || goToPage == '' || iscontainsNumber
											"
											class="qb-pagination-addbtn"
											@click="goToPageNo(goToPage)"
										>
											<span
												><img src="../../assets/whiterightarrow.svg" alt=""
											/></span>
										</b-button>
									</div>
									<div class="pagination">
										<b-pagination
											v-model.number="currentPage"
											@input="goToPageNum()"
											:total-rows="total"
											:per-page="testCount"
											align="center"
											first-number
											last-number
										>
											<template #prev-text
												><span
													><img
														src="../../assets/leftvector.svg"
														alt=""
													/> </span
											></template>
											<template #next-text
												><span
													><img src="../../assets/rightarrow.svg" alt=""/></span
											></template>
										</b-pagination>
									</div>
									<div class="qb-gotopage-text mr-2">
										Results : <span v-if="pageStart + 1 > total">0</span
										><span v-else>{{ pageStart + 1 }}</span> - {{ pageEnd }}
										<span class="pl-1"></span> of <span class="pr-1"></span
										>{{ total }}
									</div>
								</div>
							</b-tab>
							<b-tab
								@click="
									(tabIndex = 2),
										getProcteringAllTests(),
										(currentPage = 1),
										(LoaderStatus = true)
								"
								title="Active
 "
							>
								<div class="position-relative">
									<div class="vpt-test-tab-container">
										<div
											v-if="total == 0"
											class="d-flex flex-column align-items-center justify-content-center h-100"
										>
											<div v-if="searchTopicTest != ''">
												<img src="../../assets/searchnotfound.svg" alt="" />
												<div class="text-center">
													<span class="searchnotfound"
														>No matching results for
														<span class="searchtext text-break">
															"{{ searchTopicTest }}"
														</span>
													</span>
												</div>
											</div>
											<div v-else>
												<img src="../../assets/nocandidate.svg" alt="" />
												<div class="mt-3">
													<span class="nocandidate"
														>Currently there is no test.
													</span>
												</div>
											</div>
										</div>
										<template v-else
											><div
												class="d-flex align-items-center mt-3 pointer"
												v-for="(testdata, index) in gettests"
												:key="index"
												:class="[
													storeTopic.testID == testdata.testID
														? 'proct-gicards-selected'
														: 'proct-gicards',
												]"
												@click="
													storeTopic.testID == testdata.testID
														? ''
														: handleCandidateClick(testdata)
												"
											>
												<div
													class="proct-gicards-gridcolorbar"
													v-if="storeTopic.testID != testdata.testID"
												></div>
												<div class="d-flex flex-column" style="width: 35%">
													<div class="d-flex align-items-center proct-gt-tctxt">
														<div class="text-truncate mr-3">
															Topic :
															{{ getFormattedTopicName(testdata.topicName) }}
														</div>
													</div>
													<div class="proct-grpname mt-2">
														<div class="text-truncate mr-3">
															{{ testdata.testName }}
														</div>
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 15%">
													<div class="proct-gt-tctxt">Sections</div>
													<div class="proct-gt-tccounttxt">
														{{ testdata.sectionCount }}
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 25%">
													<div class="proct-gt-tctxt">Marks</div>
													<div
														v-if="testdata.marks < 10"
														class="proct-gt-candcounttxt"
													>
														0{{ testdata.marks.toString().slice(0, 4) }}
													</div>
													<div v-else class="proct-gt-candcounttxt">
														{{ testdata.marks.toString().slice(0, 5) }}
													</div>
												</div>
												<div class="d-flex" style="width: 20%">
													<div
														v-if="testdata.active"
														class="active-btn d-flex align-items-center justify-content-center"
													>
														<div class="vpt-activetxt">Active</div>
													</div>
													<!-- please note below code is for iactive  -->

													<div
														v-else
														class="inactive-btn d-flex align-items-center justify-content-center"
													>
														<div class="inactive-text-proc">Inactive</div>
													</div>
												</div>
												<div style="width: 5%">
													<img
														src="../../assets/visibility_off_black (2).svg"
														alt=""
														v-if="storeTopic.testID == testdata.testID"
													/>
													<img
														v-else
														src="../../assets/preview eye (2).svg"
														alt=""
													/>
												</div></div
										></template>
									</div>
								</div>
								<div
									class="vpt-paginaTion d-flex justify-content-between align-items-center"
								>
									<div class="d-flex">
										<span class="qb-gotopage-text p-1">Go to page</span>
										<b-form-input
											type="text"
											class="qb-pagination-num mr-1"
											v-model.trim="goToPage"
											@keyup.enter="
												goToPage === null || goToPage == '' || iscontainsNumber
													? ''
													: goToPageNo(goToPage)
											"
										></b-form-input>
										<b-button
											class="qb-pagination-addbtn"
											@click="goToPageNo(goToPage)"
											:disabled="
												goToPage === null || goToPage == '' || iscontainsNumber
											"
										>
											<span
												><img src="../../assets/whiterightarrow.svg" alt=""
											/></span>
										</b-button>
									</div>
									<div class="pagination">
										<b-pagination
											v-model.number="currentPage"
											@input="goToPageNum()"
											:total-rows="total"
											:per-page="testCount"
											align="center"
											first-number
											last-number
										>
											<template #prev-text
												><span
													><img
														src="../../assets/leftvector.svg"
														alt=""
													/> </span
											></template>
											<template #next-text
												><span
													><img src="../../assets/rightarrow.svg" alt=""/></span
											></template>
										</b-pagination>
									</div>
									<div class="qb-gotopage-text mr-2">
										Results : <span v-if="pageStart + 1 > total">0</span
										><span v-else>{{ pageStart + 1 }}</span> - {{ pageEnd }}
										<span class="pl-1"></span> of <span class="pr-1"></span
										>{{ total }}
									</div>
								</div>
							</b-tab>
							<b-tab
								@click="
									(tabIndex = 3),
										getProcteringAllTests(),
										(currentPage = 1),
										(LoaderStatus = true)
								"
								title="Yet to Start"
							>
								<div class="position-relative">
									<div class="vpt-test-tab-container">
										<div
											v-if="total == 0"
											class="d-flex flex-column align-items-center justify-content-center h-100"
										>
											<div v-if="searchTopicTest != ''">
												<img src="../../assets/searchnotfound.svg" alt="" />
												<div class="text-center">
													<span class="searchnotfound"
														>No matching results for
														<span class="searchtext text-break">
															"{{ searchTopicTest }}"
														</span>
													</span>
												</div>
											</div>
											<div v-else>
												<img src="../../assets/nocandidate.svg" alt="" />
												<div class="mt-3">
													<span class="nocandidate"
														>Currently there is no test.
													</span>
												</div>
											</div>
										</div>
										<template v-else
											><div
												class="d-flex align-items-center mt-3 pointer"
												v-for="(testdata, index) in gettests"
												:key="index"
												:class="[
													storeTopic.testID == testdata.testID
														? 'proct-gicards-selected'
														: 'proct-gicards',
												]"
												@click="
													storeTopic.testID == testdata.testID
														? ''
														: handleCandidateClick(testdata)
												"
											>
												<div
													class="proct-gicards-gridcolorbar"
													v-if="storeTopic.testID != testdata.testID"
												></div>
												<div class="d-flex flex-column" style="width: 35%">
													<div class="d-flex align-items-center proct-gt-tctxt">
														<div class="text-truncate mr-3">
															Topic :
															{{ getFormattedTopicName(testdata.topicName) }}
														</div>
													</div>
													<div class="proct-grpname mt-2">
														<div class="text-truncate mr-3">
															{{ testdata.testName }}
														</div>
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 15%">
													<div class="proct-gt-tctxt">Sections</div>
													<div class="proct-gt-tccounttxt">
														{{ testdata.sectionCount }}
													</div>
												</div>
												<div class="d-flex flex-column" style="width: 25%">
													<div class="proct-gt-tctxt">Marks</div>
													<div
														v-if="testdata.marks < 10"
														class="proct-gt-candcounttxt"
													>
														0{{ testdata.marks.toString().slice(0, 4) }}
													</div>
													<div v-else class="proct-gt-candcounttxt">
														{{ testdata.marks.toString().slice(0, 5) }}
													</div>
												</div>
												<div class="d-flex" style="width: 20%">
													<div
														v-if="testdata.active"
														class="active-btn d-flex align-items-center justify-content-center"
													>
														<div class="vpt-activetxt">Active</div>
													</div>
													<!-- please note below code is for iactive  -->

													<div
														v-else
														class="inactive-btn d-flex align-items-center justify-content-center"
													>
														<div class="inactive-text-proc">Inactive</div>
													</div>
												</div>
												<div style="width: 5%">
													<img
														src="../../assets/visibility_off_black (2).svg"
														alt=""
														v-if="storeTopic.testID == testdata.testID"
													/>
													<img
														v-else
														src="../../assets/preview eye (2).svg"
														alt=""
													/>
												</div></div
										></template>
									</div>
								</div>
								<div
									class="vpt-paginaTion d-flex justify-content-between align-items-center"
								>
									<div class="d-flex">
										<span class="qb-gotopage-text p-1">Go to page</span>
										<b-form-input
											type="text"
											class="qb-pagination-num mr-1"
											v-model.trim="goToPage"
											@keyup.enter="
												goToPage === null || goToPage == '' || iscontainsNumber
													? ''
													: goToPageNo(goToPage)
											"
										></b-form-input>
										<b-button
											:disabled="
												goToPage === null || goToPage == '' || iscontainsNumber
											"
											class="qb-pagination-addbtn"
											@click="goToPageNo(goToPage)"
										>
											<span
												><img src="../../assets/whiterightarrow.svg" alt=""
											/></span>
										</b-button>
									</div>
									<div class="pagination">
										<b-pagination
											v-model.number="currentPage"
											@input="goToPageNum()"
											:total-rows="total"
											:per-page="testCount"
											align="center"
											first-number
											last-number
										>
											<template #prev-text
												><span
													><img
														src="../../assets/leftvector.svg"
														alt=""
													/> </span
											></template>
											<template #next-text
												><span
													><img src="../../assets/rightarrow.svg" alt=""/></span
											></template>
										</b-pagination>
									</div>
									<div class="qb-gotopage-text mr-2">
										Results : <span v-if="pageStart + 1 > total">0</span
										><span v-else>{{ pageStart + 1 }}</span> - {{ pageEnd }}
										<span class="pl-1"></span> of <span class="pr-1"></span
										>{{ total }}
									</div>
								</div>
							</b-tab>
						</b-tabs>
					</div>
				</div>
				<div v-if="total != 0" class="proct-test-right-container-1 mt-3 ml-3">
					<div
						v-if="nodata"
						class="d-flex align-items-center justify-content-center h-100"
					>
						<img src="../../assets/nogroupdata.svg" alt="" />
					</div>
					<template v-else>
						<ViewProctorTestDetails
							:showSpinner="showSpinner"
							:particularView="particularView"
							:allData="
								this.$route.params.candidateType == 'I'
									? this.candidateDetails
									: allData
							"
							:showProctoring="showProctoring"
							:tabIndex="tabIndex"
							:queryName="$route.query.name"
							:querySummary="$route.query.summary"
							:queryEvaluated="$route.query.evaluated"
							:queryGroups="$route.query.groups"
							:querySort="Number($route.query.sort)"
							:queryStatus="$route.query.status"
							@store-payload="storePayload"
						/>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getProcteringAllTests,
	getEvalTestCandidates,
	getproctoringCandidates,
	getProcteringFilter,
	postTaggedEvalTest,
} from "../../utils/apiFunctions.js";
import { mapGetters, mapMutations } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import errorToast from "../../views/mixin/toast";
import ViewProctorTestDetails from "./ViewProctorTestDetails.vue";
export default {
	name: "ViewProctorTestScreen",
	components: {
		Spinner,
		ViewProctorTestDetails,
		// Spinner,ß
	},

	mixins: [errorToast],

	data() {
		return {
			showSpinner: false,
			showName: false,
			LoaderStatus: false,
			tabIndex: 0,
			filterPageEnd: null,
			totalFilterData: null,
			showtypecard: false,
			selTopicName: "",
			storeTopicId: "",
			page: 0,
			showLoaderfilter: true,
			testCount: "50",
			searchFilter: "",
			typeselected: "2",
			onclickeye: true,
			groupcards: 9,
			selectFirstCard: {},
			particularView: false,
			// testCardselected: 'Active',

			candidatesDetails: {
				candidateList: [],
			},
			typeoptions: [
				{ text: "All", value: "2" },
				{ text: "Active", value: "1" },
				{ text: "Inactive", value: "0" },
			],
			singleCandidatesDetails: {},
			candidateImage: "",
			candDetails: {},
			allCandidates: [],
			sectionDetails: [],
			testCardselected: "Active",
			activeForTest: "true",
			individualMarks: {},
			showGroups: false,
			gettests: [],
			totaltests: {},
			allData: {
				data: [],
			},
			candidateDetails: {},
			selectedGroup: {
				groupName: "",
				createdAt: "",
				candidates: [],
			},
			testTypeOptions: [
				{ text: "All", value: "" },
				{ text: "Active", value: "true" },
				{ text: "Inactive", value: "false" },
			],
			groups: [],
			name: "",
			pageStart: "",
			status: "",
			pageEnd: "",
			prevPg: "",
			showtest: false,
			showtestcard: false,
			total: null,
			currentPage: 1,
			curPage: 1,
			sortOrder: -1,
			count: 10,
			sortorder: false,
			sorting: false,
			applyfilter: false,
			goToPage: null,
			totalPages: null,
			addressView: false,
			particularCandidatestore: {},
			storeTopic: {},
			savePayload: {},
			empty: {},
			storeTab: "",
			storeTestId: "",
			sortcolumn: "",
			getTestid: "",
			showtestconfig: false,
			topicName: "",
			showviewgroup: true,
			nodata: false,
			sortColumn: "createdAt",
			candidateID: "",
			filterview: false,
			filterTopic: [],
			filterTest: [],
			selectedTest: [],
			selectedTopic: [],
			storeSelectedTest: [],
			storeSelectedTopic: [],
			selectedTopicIndex: null,
			storeFilterTopic: [],
			testConfigData: {
				config: {
					dispCount: "",
				},
			},
			completed: null,
			ongoing: null,
			viewCandidate: false,
			showProctoring: "",
		};
	},

	created() {
		this.LoaderStatus = true;
		this.getProctoringFilterData("GRP_TOPIC");
		// Function to manage tab redirect
		this.tabRedirect();
		console.log(this.allData);
	},
	watch: {
		searchTopicTest(newValue, oldValue) {
			if (newValue != oldValue) {
				this.currentPage = 1;
				this.getProcteringAllTests();
				if (this.$route.params.candidateType === "G") {
					this.closeParticularCandidate();
				}
			}
		},
		typeselected() {
			this.$router.push({
				name: "ViewProctorTestScreen",
				query: {
					name: this.$route.query.name,
					summary: this.$route.query.summary,
					evaluated: this.$route.query.evaluated,
					groups: this.$route.query.groups,
					sort: this.typeselected,
					status: this.$route.query.status,
				},
			});
		},
		tabIndex(newValue) {
			let status;
			// Map the tabIndex value to the corresponding status
			switch (newValue) {
				case 0:
					status = "all";
					break;
				case 1:
					status = "completed";
					break;
				case 2:
					status = "ongoing";
					break;
				case 3:
					status = "yetToStart";
					break;
				default:
					status = "pending";
					break;
			}
			// Update the route with the new status query parameter
			this.$router.push({
				name: "ViewProctorTestScreen",
				query: {
					name: this.$route.query.name,
					summary: this.$route.query.summary,
					evaluated: this.$route.query.evaluated,
					groups: this.$route.query.groups,
					sort: this.typeselected,
					status: status,
				},
			});
		},
	},
	computed: {
		iscontainsNumber() {
			return !/^\d+$/.test(this.goToPage);
		},
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters("proctoringVUEX", {
			getPayload: "getPayloadData",
			getStoreTestID: "getStoreTestID",
		}),
		...mapGetters(["roles"]),
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" +
					Math.random()
						.toString(16)
						.slice(-6),
			};
		},

		filtercandidatesDetails() {
			return this.candidatesDetails.candidateList.filter((data) => {
				return (
					!this.searchTopicTest ||
					data.emailID
						.toLowerCase()
						.includes(this.searchTopicTest.toLowerCase())
				);
			});
		},
	},
	methods: {
		...mapMutations("proctoringVUEX", {
			setPayload: "setPayloadData",
			setStoreTestID: "setStoreTestID",
		}),
		getFormattedTopicName(topicName) {
			if (topicName === "Sandbox-KSGPdd3q0S#jl@B") return "Sandbox";
			else return topicName;
		},
		// Function to manage tab redirect
		tabRedirect() {
			if (this.$route.query.status || this.$route.query.sort) {
				this.typeselected = this.$route.query.sort;
				switch (this.$route.query.status) {
					case "all":
						this.tabIndex = 0;
						this.getProcteringAllTests();
						break;
					case "completed":
						this.tabIndex = 1;
						this.getProcteringAllTests();
						break;
					case "ongoing":
						this.tabIndex = 2;
						this.getProcteringAllTests();
						break;
					case "yetToStart":
						this.tabIndex = 3;
						this.getProcteringAllTests();
						break;
				}
				return;
			}
			this.getProcteringAllTests();
		},
		hideTestFunction() {
			this.showtypecard = false;
		},
		handleCandidateClick(testdata) {
			this.showProctoring = testdata.status;
			if (
				this.$route.params.candidateType === "G" ||
				this.$route.params.candidateType == "R"
			) {
				this.viewCandidates(testdata);
				this.closeParticularCandidate();
			} else {
				this.viewIndividualCandidate(testdata);
			}
		},
		searchFilterM() {
			this.page = 0;
			this.showLoaderfilter = true;
			this.getProctoringFilterData(!this.showtest ? "GRP_TOPIC" : "TEST");
		},
		storePayload() {
			this.setPayload(this.savePayload);
			this.setStoreTestID(this.storeTopic);
		},
		async getProctoringFilterData(type) {
			let payload = {
				topicID: this.storeTopicId,
				filterType: type,
				page: this.page,
				groupID: this.$route.params.groupID,
				searchQuery: this.searchFilter,
			};
			if (payload.searchQuery == "") {
				delete payload.searchQuery;
			}
			if (payload.topicID == "") {
				delete payload.topicID;
			}
			const res = await getProcteringFilter(payload);
			if (res.status == 200) {
				this.showLoaderfilter = false;
				if (type === "TEST") {
					this.getProcteringFilterDataTest(res);
				} else {
					this.filterTopic =
						this.page === 0
							? res.data.data.data
							: [...this.filterTopic, ...res.data.data.data];
					this.filterTest = this.page === 0 ? [] : this.filterTest;
				}
				this.filterPageEnd = res.data.data.pageEnd;
				this.totalFilterData = res.data.data.total;
			}
		},

		getProcteringFilterDataTest(res) {
			this.filterTest =
				this.page === 0
					? res.data.data.data
					: [...this.filterTest, ...res.data.data.data];
			this.showtest = this.page === 0;
			this.filterTopic = this.page === 0 ? [] : this.filterTopic;
		},
		async filter() {
			this.page = 0;
			this.searchFilter = "";
			this.filterview = !this.filterview;
			this.selectedTest = [...this.storeSelectedTest];
			this.selectedTopic = [...this.storeSelectedTopic];
			this.showLoaderfilter = true;
			await this.getProctoringFilterData("GRP_TOPIC");
			this.showtest = false;
			if (!this.applyfilter) {
				this.selectedTopic = [];
				this.selectedTest = [];
			}
		},
		clearfilter() {
			this.searchFilter = "";
			this.page = 0;
			this.selectedTopic = [];
			this.selectedTest = [];
			this.showLoaderfilter = true;
			this.getProctoringFilterData(!this.showtest ? "GRP_TOPIC" : "TEST");
			if (this.storeSelectedTest.length != 0) {
				this.storeSelectedTest = [];
				this.storeSelectedTopic = [];
				this.getProctoringFilterData(!this.showtest ? "GRP_TOPIC" : "TEST");
				this.getProcteringAllTests();
				this.applyfilter = false;
				this.filterview = false;
			}
		},
		closeFilter() {
			this.searchFilter = "";
			this.storeTopicId = "";
			this.filterTopic = [];
			this.filterTest = [];
			this.filterview = false;
		},
		onclear() {
			if (this.selectedTest.length == 0 && this.applyfilter) {
				this.applyfilter = false;
				this.getProcteringAllTests();
			}
		},
		async getProcteringAllTests() {
			this.resetData();
			const tabs = this.determineTabs();
			this.savePayload = {
				groupID: this.$route.params.groupID,
				active: this.typeselected,
				page: (this.currentPage - 1).toString(),
				count: this.testCount,
				tab: tabs,
				testIDs: this.selectedTest,
				searchQuery: this.searchTopicTest,
			};
			if (this.savePayload.testIDs.length == 0) {
				delete this.savePayload.testIDs;
			}
			let res;
			this.storeSelectedTest = [...this.selectedTest];
			this.storeSelectedTopic = [...this.selectedTopic];
			if (
				this.roles.includes("GET_EVALUATOR_TEST") &&
				!this.roles.includes("GET_PROCTORING")
			) {
				res = await postTaggedEvalTest(this.savePayload);
			} else if (Object.keys(this.getPayload).length === 0) {
				res = await getProcteringAllTests(this.savePayload);
			} else {
				res = await getProcteringAllTests(this.getPayload);
				this.setPayload(this.empty);
			}
			if (res.status == 200) {
				this.nodata = false;
				this.LoaderStatus = false;
				this.gettests = res.data.data.data;
				this.totaltests = res.data.data;
				this.storeTab = tabs;
				if (res.data.data["candidateID"] != undefined) {
					this.candidateID = res.data.data.candidateID;
				}
				this.selectFirstCard = this.gettests[0];
				this.handleCandidateType();
				this.updatePaginationData(res.data.data);
			}
		},
		resetData() {
			this.showProctoring = "";
			this.gettests = [];
			if (this.$route.params.candidateType === "G") {
				this.closeParticularCandidate();
			}
		},
		determineTabs() {
			if (this.tabIndex == 0) return "all";
			if (this.tabIndex == 1) return "expired";
			if (this.tabIndex == 2) return "active";
			return "yetToStart";
		},
		handleCandidateType() {
			if (
				this.$route.params.candidateType == "G" ||
				this.$route.params.candidateType == "R"
			) {
				this.handleGroupCandidateType();
			} else if (this.$route.params.candidateType == "I") {
				this.handleIndividualCandidateType();
			}
		},
		handleGroupCandidateType() {
			if (this.gettests.length > 0) {
				if (Object.keys(this.getStoreTestID).length != 0) {
					this.viewCandidates(this.getStoreTestID);
					this.setStoreTestID(this.empty);
				} else {
					this.viewCandidates(this.gettests[0]);
				}
			} else {
				this.nodata = true;
			}
		},
		handleIndividualCandidateType() {
			if (this.gettests.length > 0) {
				if (Object.keys(this.getStoreTestID).length != 0) {
					this.viewIndividualCandidate(this.getStoreTestID);
					this.setStoreTestID(this.empty);
				} else {
					this.viewIndividualCandidate(this.gettests[0]);
				}
			} else {
				this.nodata = true;
				this.closeParticularCandidate();
			}
		},
		updatePaginationData(data) {
			this.pageEnd = data.pageEnd;
			this.pageStart = data.pageStart;
			this.total = data.total;
			this.getTestid = this.$route.query.testID;
			this.totalPages = Math.ceil(
				parseInt(this.total) / parseInt(this.testCount)
			);
		},
		getTestValue(data) {
			this.activeForTest = data;
			this.getProcteringAllTests();
		},
		async gotoFourthPage() {
			this.$router.push({
				path: `/proctoring/evaluatetest/${this.storeTopic.testID}/${this.storeTopic.topicID}/${this.$route.params.groupID}/${this.storeTopic.candidateID}/${this.$route.params.candidateType}`,
			});
		},
		async gotoFourthPageGroup(data) {
			this.$router.push({
				path: `/proctoring/evaluatetest/${data.testID}/${data.topicID}/${data.groupID}/${data.candidateID}/${this.$route.params.candidateType}`,
			});
		},

		viewGroupInfo(data) {
			this.selectedGroup = data;
		},
		async getevaldata(i) {
			this.showSpinner = true;
			try {
				let payload = {
					page: this.curPage - 1,
					count: "all",
					testID: i.testID,
					groupID: this.$route.params.groupID,
				};

				const res = await getEvalTestCandidates(payload);
				if (res.status == 200) {
					this.allData = res.data.data;
					this.showSpinner = false;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async getProctorCandDetails(value) {
			this.showSpinner = true;
			let payload = {
				topicID: value.topicID,
				testID: value.testID,
				groupID: value.groupID,
				candidateID: value.candidateID,
			};
			const res = await getproctoringCandidates(payload);
			if (res.status == 200) {
				this.candidateDetails = res.data.data;
				this.showSpinner = false;
			}
		},
		// ASSIGN MARKS FOR B-MODAL
		assignMark(progress, name) {
			this.name = name;
			this.individualMarks = progress;
			this.$bvModal.show("totalmarks");
		},
		// TOGGLE ATTEMPT BUTTON
		showAttempts(progress) {
			progress.viewAttempts = !progress.viewAttempts;
			this.$forceUpdate();
		},
		copy() {
			this.storeFilterTopic = this.filterTopic.slice();
		},
		selectTopicIDS(topicID, testIDs, index) {
			this.selectedTopicIndex = index;
			if (this.selectedTopic.includes(topicID)) {
				for (let i in testIDs) {
					this.selectedTest.push(testIDs[i]);
				}
			} else {
				for (let j in testIDs) {
					this.selectedTest = this.selectedTest.filter((id) => {
						return id != testIDs[j];
					});
				}
			}
		},
		selectTestIDs(topicID) {
			const hasAllElems = this.storeFilterTopic[
				this.selectedTopicIndex
			].testIDs.every((elem) => this.selectedTest.includes(elem));

			if (hasAllElems && !this.selectedTopic.includes(topicID)) {
				this.selectedTopic.push(topicID);
				return; // Early return if the condition is met
			}

			if (!hasAllElems && this.selectedTopic.includes(topicID)) {
				this.selectedTopic = this.selectedTopic.filter((id) => id !== topicID);
			}
			// If topicID is already in selectedTopic and hasAllElems is true, we don't need to do anything.
		},
		scroll(e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				//this code will run when the user scrolls to the bottom of this div so
				//you could do an api call here to implement lazy loading

				if (this.checkbetween(this.filterPageEnd, 0, this.totalFilterData)) {
					this.page++;
					this.getProctoringFilterData(!this.showtest ? "GRP_TOPIC" : "TEST");
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		async closeTest() {
			this.searchFilter = "";
			this.storeTopicId = "";
			this.page = 0;
			this.showLoaderfilter = true;
			await this.getProctoringFilterData("GRP_TOPIC");
			this.showtest = false;
		},
		closeTopic(data) {
			this.searchFilter = "";
			this.selTopicName = data.name;
			this.storeTopicId = data.topicID;
		},
		// FORMAT DATE
		formatDate(inputDate, format) {
			const date = new Date(inputDate);
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			format = format.replace("MM", month.toString().padStart(2, "0"));
			if (format.indexOf("yyyy") > -1) {
				format = format.replace("yyyy", year.toString());
			} else if (format.indexOf("yy") > -1) {
				format = format.replace("yy", year.toString().slice(-2));
			}
			format = format.replace("dd", day.toString().padStart(2, "0"));
			return format;
		},
		viewIndividualCandidate(data) {
			this.storeTopic = data;
			this.storeTopic.candidateID = this.totaltests.candidateID;
			let obj = {
				testID: data.testID,
				topicID: data.topicID,
				groupID: this.$route.params.groupID,
				candidateID: this.totaltests.candidateID,
			};
			this.storeTestId = data.testID;
			this.particularView = true;
			this.getProctorCandDetails(obj);
		},
		goToDashboard() {
			this.$router.push({
				path: "/proctoring",
				query: {
					redirect: this.$route.params.candidateType,
					summary: this.$route.query.summary,
					evaluated: this.$route.query.evaluated,
					groups: this.$route.query.groups,
				},
			});
		},
		viewParticularCandidate(data) {
			this.storeTopic = data;
			this.particularView = true;
			this.getProctorCandDetails(data);
		},
		closeParticularCandidate() {
			this.particularView = false;
		},
		viewCandidateModal(data) {
			this.particularCandidatestore = data;
		},
		// CLOSE B-MODAL
		closeTotalMarks() {
			this.name = "";
			this.individualMarks = {};
			this.$bvModal.hide("totalmarks");
		},
		goToPageNo(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.getProcteringAllTests();

			this.goToPage = null;
		},
		goToPageNum() {
			this.getProcteringAllTests();
		},

		viewCandidates(data) {
			this.storeTopic = data;
			this.getevaldata(data);
		},
	},
};
</script>

<style>
.gotoprocttxt {
	color: #72738e;
	font-size: 15px;
	font-weight: 600;
	text-decoration-line: underline;
}
.canddet-txt {
	color: #72738e;
	font-size: 15px;
	font-weight: 600;
}
.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.vptsortcontainer {
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border: 1px solid #72738e;

	border-radius: 3px;
	padding: 5px 15px;
	text-align: left;
}

.vpt-reportbtn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 95px;
	text-align: center;
}
.vpt-testbtn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 240px;
	text-align: center;
}
.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}
.proct-content-container {
	height: calc(100vh - 140px);
}
.proct-test-viewcontainer .nav-tabs {
	border-bottom: 1px solid #dbdbe2;
}
.vpt-paginaTion {
	width: 100%;
	padding: 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.proct-test-viewcontainer {
	width: 70%;
	height: calc(100vh - 195px);
	position: relative;
}
.proct-test-viewcontainer-full {
	width: 100%;
	height: calc(100vh - 195px);
	position: relative;
}

.tabbed ul li a:before {
	top: -2px;
	height: 110%;
}

.nav-tabs {
	border-bottom: none;
	overflow: hidden;
}

.proct-gicards {
	background: #ffffff;
	border: 2px solid #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	position: relative;
	margin-right: 3px;
}
.proct-gicards-selected {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	position: relative;
	margin-right: 3px;
}

.proct-gicards-gridcolorbar {
	width: 4px;
	background: #f04e92;
	border-radius: 2px;
	position: absolute;
	left: 5px;
	top: 5px;
	height: 90%;
}

.proct-grpname {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}

.proct-gt-tctxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.proct-gt-tccounttxt {
	font-weight: 500;
	font-size: 14px;
	color: #84a3fe;
}

.active-btn {
	width: 81px;
	height: 23px;
	background: #ccfacb;
	border-radius: 3px;
}

.vpt-activetxt {
	font-weight: 400;
	font-size: 12px;
	color: #038e00;
}

.inactive-btn {
	width: 81px;
	height: 23px;
	background: #ffeeee;
	border-radius: 3px;
}

.inactive-text-proc {
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}

.vpt-test-tab-container {
	height: calc(100vh - 245px);
	overflow: auto;
}

.twobtns {
	position: absolute;
	bottom: 170px;
	right: 20px;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.address-text {
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.email {
	border: 1px solid #f4f4f4;
}

.proct-test-right-container-1 {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgb(196 196 196 / 50%);
	border-radius: 8px;
	width: 30%;
	padding: 10px;
	height: calc(100vh - 190px);
	position: relative;
	overflow: auto;
	top: 35px;
}
.pr-test-cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 355px;
	height: 320px;
	right: 10px;
	top: 55px;
}
.pr-test-sortcard {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 55px;
	right: 117px;
	padding: 5px 15px;
	position: absolute;
	z-index: 7;
	font-size: var(--size-13);
	color: #545454;
}
.viewmark-heading {
	font-weight: 600;
	font-size: 13px;
	color: #545454;
}
.viewmark-testbox-subtestname {
	font-weight: 400;
	font-size: 14px;
	color: #696969;
}
.viewmark-date-txt {
	font-weight: 400;
	font-size: 12px;
	color: #6d6d6d;
}
.viewmark-section-txt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
#viewdetailsmodal .modal-content {
	border-radius: 10px;
	height: 80vh;
}
.viewmark-attempt-open-box {
	background: #f8f8f8;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin-bottom: 15px;
}
.viewmark-open-atmpt-box {
	background: #f5f5f5;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 6px 6px 0px 0px;
	padding: 15px !important;
	margin-top: 15px;
}

.vpts-recsearchicon-pos {
	position: absolute;
	top: 7px;
	left: 5px;
}
</style>
